<template>
  <div class="v-title">
    <div>
      <span>{{ title }}</span>
      <slot name="append" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-title {
  font-size: 14px;
  line-height: 20px;
  color: #333;
  padding-left: 12px;
  position: relative;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 6px;
    height: 100%;
    background: #409eff;
  }
}
</style>
